"use strict";
/**
 * 打关数据格式化类 ver: 2
 * v1基础上去除了一些对特殊字符 的转译
 *
 */
const POS_ARY = [11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35, 36, 37, 38, 39, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 53, 54, 55, 56, 57, 58, 59, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 72, 73, 74, 75, 76, 77, 78, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99];
const ASCII_ARY = "!#$%&()*+,-.0123456789:;<=>?ABCDEFGHIJKLMNOPQRSTUVWXYZ[]_abcdefghijklmnopqrstuvwx";
const ReplayDataFormatter_v1 = require("./ReplayDataFormatter_v1");
class ReplayDataFormatter_v2 extends ReplayDataFormatter_v1 {
    constructor() {
        super();
    }
    toAscii(v4) {
        if (__DEBUG) {
            let ary = [v4.x1, v4.y1, v4.x2, v4.y2];
            ary.forEach((v => assert(v >= 1 && v <= 9, "swap data outof range! x1, y1, x2, y2 = " + ary.join(","))));
        }
        let index1 = POS_ARY.indexOf(v4.x1 * 10 + v4.y1);
        let index2 = POS_ARY.indexOf(v4.x2 * 10 + v4.y2);
        return `${ASCII_ARY[index1]}${ASCII_ARY[index2]}`;
    }
    toV4(str, index) {
        let index1 = ASCII_ARY.indexOf(str[index]);
        let index2 = ASCII_ARY.indexOf(str[index + 1]);
        let v1 = POS_ARY[index1];
        let v2 = POS_ARY[index2];
        return {
            x1: Math.floor(v1 / 10),
            y1: v1 % 10,
            x2: Math.floor(v2 / 10),
            y2: v2 % 10,
        };
    }
}
module.exports = ReplayDataFormatter_v2;
